import { render, staticRenderFns } from "./PlusRecentProjects.vue?vue&type=template&id=5fef3144&scoped=true"
import script from "./PlusRecentProjects.vue?vue&type=script&lang=js"
export * from "./PlusRecentProjects.vue?vue&type=script&lang=js"
import style0 from "./PlusRecentProjects.vue?vue&type=style&index=0&id=5fef3144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef3144",
  null
  
)

export default component.exports